import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  productTypeDelete (params) {
    return axios.post(global.PMC_INFO + '/type/deleteProductTypeById', params)
  },
  productFindAll (params) {
    return axios.post(global.PMC_INFO + '/type/findAllProductTypeTree', params)
  },
  productFindAllProductType (params) {
    return axios.post(global.PMC_INFO + '/type/findAllProductType', params)
  },
  productAdd (params) {
    return axios.post(global.PMC_INFO + '/type/addProductTypeSpecAttribute', params)
  },
  productUpdate (params) {
    return axios.post(global.PMC_INFO + '/type/updateProductTypeSpecAttribute', params)
  },
  productFindProductTypeSpecById (params) {
    return axios.post(global.PMC_INFO + '/type/findProductTypeSpecById', params)
  },
  productFindProductTypeAttribute (params) {
    return axios.post(global.PMC_INFO + '/type/findProductTypeAttributeWhenUpdate', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/pmc/productType.js